import React, { useCallback } from 'react';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';
import { ConfirmDialog } from '@gogame/components';

import { deleteChat } from 'scenes/AIChatbot/sources/chats';
import { deleteChat as key } from 'scenes/AIChatbot/data/queryKeyFactory';

export const useDeleteChat = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const mutation = useMutation(key(), deleteChat, {
    successMessage: () => `Chat deleted`,
    errorMessage: (e) => e.message,
  });

  const handleAction = useCallback(
    async ({ id }) => {
      await showModal({
        title: `Delete Chat?`,
        confirmActionLabel: 'Delete',
      });
      await mutation.mutateAsync({ id });
    },
    [mutation, showModal]
  );

  return [handleAction, mutation];
};
